const nameApplications = {
    "gitlab": "Gitlab",
    "pgadmin": "PgAdmin",
    "openvpn": "VPN",
    "airbyte": "Airbyte"
}

export default nameApplications